import { render, staticRenderFns } from "./DiDetails.vue?vue&type=template&id=7167c9d2&scoped=true&"
import script from "./DiDetails.vue?vue&type=script&lang=js&"
export * from "./DiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7167c9d2",
  null
  
)

export default component.exports